// @flow
import * as at from './action-types';
// types
import type { ResourceName } from '../modules/api/resources';
import type { Method } from '../modules/api/http';

import { type FSA } from 'modules/fsa';

export type RequestResourceAction = FSA<
  typeof at.RESOURCE_REQUEST,
  $ReadOnly<{|
    resourceName: ResourceName,
    method: Method,
    data: any,
    resourceId: ?string,
  |}>,
>;

export type ReceiveResourceAction = FSA<
  typeof at.RESOURCE_RECEIVE,
  $ReadOnly<{|
    resourceName: ResourceName,
    method: Method,
    data: any,
    resourceId: ?string,
  |}>,
>;

export type FailToReceiveResourceAction = FSA<
  typeof at.RESOURCE_FAIL_TO_RECEIVE,
  $ReadOnly<{|
    resourceName: ResourceName,
    method: Method,
    error: string,
    resourceId: ?string,
  |}>,
>;

export const requestResource = (
  resourceName: ResourceName,
  method: Method,
  resourceId?: string | null,
  ...data: any
): RequestResourceAction => ({
  type: at.RESOURCE_REQUEST,
  payload: {
    resourceName,
    method,
    resourceId,
    ...data,
  },
  meta: { name: 'Requested Resource' },
});

export const receiveResource = (
  resourceName: ResourceName,
  method: Method,
  resourceId: string | null,
  data: any,
): ReceiveResourceAction => ({
  type: at.RESOURCE_RECEIVE,
  payload: {
    resourceName,
    method,
    resourceId,
    data,
  },
  meta: { name: 'Received Resource' },
});

export const failToReceiveResource = (
  resourceName: ResourceName,
  method: Method,
  resourceId: string | null,
  error: string,
): FailToReceiveResourceAction => ({
  type: at.RESOURCE_FAIL_TO_RECEIVE,
  payload: {
    resourceName,
    method,
    resourceId,
    error,
  },
  meta: { name: 'Error Fetching Resource' },
});
